"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchMyPreferencesEndpoint = void 0;
const endpoint_1 = require("../../general/endpoint");
class FetchMyPreferencesEndpoint extends endpoint_1.BaseGetEndpoint {
    getUrl() {
        return `/v2/me/preferences/account`;
    }
}
exports.FetchMyPreferencesEndpoint = FetchMyPreferencesEndpoint;
